import {
  TypedUseSelectorHook,
  useSelector as useSelectorRedux,
} from 'react-redux';
import { OwlStore } from '@owl-frontend/redux';
import claimOverviewSlice from '../components/ClaimOverviewContainer/data/logic';
import claimOverviewShellSlice from '../components/ClaimOverviewShellContainer/data/logic';
import owlShellTemplateSlice from '../components/ClaimOverviewShellContainer/data/templates/logic';
import claimsSlice from '../components/ClaimsContainer/data/logic';
import activitiesSlice from './activities/logic';
import chatSlice from './chat/logic';
import featureFlagsSlice from './feature_flags/logic';
import feedbackSlice from './feedback/logic';
import filesSlice from './files/logic';
import localizationSlice from './localization/logic';
import notificationsSlice from './notifications/logic';
import runsSlice from './runs/logic';
import searchSlice from './search/logic';
import sessionSlice from './session/logic';
import statusSlice from './status/logic';
import storeOptions from './storeOptions';
import userEventsSlice from './userEvents/logic';
import usersSlice from './users/logic';
import wsSlice from './ws/logic';

// MARK: Claim Overview
const store = new OwlStore([], {}, storeOptions);
store.addSlice(activitiesSlice);
store.addSlice(chatSlice);
store.addSlice(claimOverviewSlice);
store.addSlice(claimsSlice);
store.addSlice(featureFlagsSlice);
store.addSlice(userEventsSlice);
store.addSlice(feedbackSlice);
store.addSlice(filesSlice);
store.addSlice(localizationSlice);
store.addSlice(notificationsSlice);
store.addSlice(runsSlice);
store.addSlice(searchSlice);
store.addSlice(sessionSlice);
store.addSlice(usersSlice);
store.addSlice(wsSlice);
store.addSlice(statusSlice);

// MARK: Claim Overview Shell
store.addSlice(claimOverviewShellSlice);
store.addSlice(owlShellTemplateSlice);

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./activities/logic', () =>
    store.addSlice(activitiesSlice, true)
  );
  module.hot.accept('./chat/logic', () => store.addSlice(chatSlice, true));
  module.hot.accept('../components/ClaimOverviewContainer/data/logic', () =>
    store.addSlice(claimOverviewSlice, true)
  );
  module.hot.accept('../components/ClaimsContainer/data/logic', () =>
    store.addSlice(claimsSlice, true)
  );
  module.hot.accept('./feature_flags/logic', () =>
    store.addSlice(featureFlagsSlice, true)
  );
  module.hot.accept('./userEvents/logic', () =>
    store.addSlice(userEventsSlice, true)
  );
  module.hot.accept('./feedback/logic', () =>
    store.addSlice(feedbackSlice, true)
  );
  module.hot.accept('./files/logic', () => store.addSlice(filesSlice, true));
  module.hot.accept('./localization/logic', () =>
    store.addSlice(localizationSlice, true)
  );
  module.hot.accept('./runs/logic', () => store.addSlice(runsSlice, true));
  module.hot.accept('./search/logic', () => store.addSlice(searchSlice, true));
  module.hot.accept('./session/logic', () =>
    store.addSlice(sessionSlice, true)
  );
  module.hot.accept('./users/logic', () => store.addSlice(usersSlice, true));
  module.hot.accept('./users/logic', () => store.addSlice(wsSlice, true));
  module.hot.accept('./status/logic', () => store.addSlice(statusSlice, true));

  // MARK: Claim Overview Shell
  module.hot.accept(
    '../components/ClaimOverviewShellContainer/data/logic',
    () => store.addSlice(claimOverviewShellSlice, true)
  );
  module.hot.accept(
    '../components/ClaimOverviewShellContainer/data/templates/logic',
    () => store.addSlice(owlShellTemplateSlice, true)
  );
}
export interface StoreState {
  [activitiesSlice.name]: (typeof activitiesSlice)['initialState'];
  [chatSlice.name]: (typeof chatSlice)['initialState'];
  [claimOverviewSlice.name]: (typeof claimOverviewSlice)['initialState'];
  [claimsSlice.name]: (typeof claimsSlice)['initialState'];
  [featureFlagsSlice.name]: (typeof featureFlagsSlice)['initialState'];
  [userEventsSlice.name]: (typeof userEventsSlice)['initialState'];
  [feedbackSlice.name]: (typeof feedbackSlice)['initialState'];
  [filesSlice.name]: (typeof filesSlice)['initialState'];
  [localizationSlice.name]: (typeof localizationSlice)['initialState'];
  [notificationsSlice.name]: (typeof notificationsSlice)['initialState'];
  [runsSlice.name]: (typeof runsSlice)['initialState'];
  [searchSlice.name]: (typeof searchSlice)['initialState'];
  [sessionSlice.name]: (typeof sessionSlice)['initialState'];
  [usersSlice.name]: (typeof usersSlice)['initialState'];
  [wsSlice.name]: (typeof wsSlice)['initialState'];
  [statusSlice.name]: (typeof statusSlice)['initialState'];

  // MARK: Claim Overview Shell
  [claimOverviewShellSlice.name]: (typeof claimOverviewShellSlice)['initialState'];
  [owlShellTemplateSlice.name]: (typeof owlShellTemplateSlice)['initialState'];
}
export default store as OwlStore<any> as OwlStore<StoreState>;
export const useSelector: TypedUseSelectorHook<StoreState> = useSelectorRedux;
